import React, { Component } from 'react'

import YAML from 'yaml'

import { withSnackbar } from 'notistack'

// @ts-ignore
import CodeMirror from '@uiw/react-codemirror'

import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/scroll/simplescrollbars.css'
import 'codemirror/addon/scroll/simplescrollbars'
import 'codemirror/mode/yaml/yaml'
import 'codemirror/theme/darcula.css'
import classNames from 'classnames'

class ParamsEditor extends Component {// Need to use class or codemirror wont update props ref, which cause wrong update of state
  state = {
    focus: false,
  }

	handleBlur = function(e: any) {
    try {
      const strValue = e.getValue().replaceAll('\t', '  ')//.getTextArea().nextElementSibling.innerText.substr(0, e.getTextArea().nextElementSibling.innerText.length - 1) //.replaceAll('\u200b', '')
      // console.log({ strValue })
      // console.log({ strValue, boo: test2Yaml === strValue })

			// @ts-ignore
      this.props.onChange(YAML.parse(strValue, { prettyErrors: true }))

    }
    catch (error) {
			// @ts-ignore
      this.props.enqueueSnackbar(this.props.name + ' : ' + error.message, { variant: 'error' })
      console.log({ error })
    }
    // @ts-ignore
    this.setState({ focus: false })
  }

	render() {
		const {
			// @ts-ignore
			value,
			// @ts-ignore
      height = 120,
      // @ts-ignore
      style = { margin: '12px 0' }
		} = this.props

		return (
      // @ts-ignore
      <div style={style} className={classNames({ ['codemirror-focus']: this.state.focus })}>
        <CodeMirror
          value={YAML.stringify(value)}
          options={{
            tabSize: 2,
            mode: 'text/yaml',
            dragDrop: false,
            lineNumbers: false,
            scrollbarStyle: 'overlay',
            theme: 'darcula',
          }}
          onFocus={() => this.setState({ focus: true })}
          onBlur={(e: any) => this.handleBlur(e)}
          // onChange={(editor, data, value) => {
          // }}
          // @ts-ignore
          height={height}
        />

      </div>
		)
	}
}

// @ts-ignore
export default withSnackbar(ParamsEditor)